import { useId, useMemo } from "react";
import { allTimeZones } from "../lib/tz";

/** Searchable IANA time zone picker (native datalist; free text validated against the list). */
export function TimeZoneSelect({
  value,
  onChange,
  label = "Time zone",
  suggestion,
  id,
}: {
  value: string;
  onChange: (tz: string) => void;
  label?: string;
  /** Offered as a one-click suggestion (e.g. the browser zone). */
  suggestion?: string;
  id?: string;
}) {
  const zones = useMemo(() => allTimeZones(), []);
  const autoId = useId();
  const inputId = id ?? `tz-${autoId}`;
  const listId = `${inputId}-list`;
  const valid = zones.includes(value);
  return (
    <div className="field">
      <label htmlFor={inputId}>
        <span>{label}</span>
      </label>
      <input
        id={inputId}
        list={listId}
        value={value}
        autoComplete="off"
        spellCheck={false}
        placeholder="Search, e.g. Europe/Zurich"
        aria-invalid={!valid}
        onChange={(e) => onChange(e.target.value)}
        onFocus={(e) => e.currentTarget.select()}
      />
      <datalist id={listId}>
        {zones.map((z) => (
          <option key={z} value={z} />
        ))}
      </datalist>
      {!valid && value && <span className="form-error small">Unknown time zone – pick one from the list.</span>}
      {suggestion && suggestion !== value && (
        <button type="button" className="btn-link small tz-suggest" onClick={() => onChange(suggestion)}>
          Use this device's zone: {suggestion}
        </button>
      )}
    </div>
  );
}

export function isKnownTimeZone(tz: string): boolean {
  return allTimeZones().includes(tz);
}
